export default __webpack_public_path__ + "static/media/Cabine Medadom (2).f75b6859.png";